__turbopack_context__.v({
  "root": "MobileTable-module__H8ihZW__root",
});
